<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <div>
            <loading
                    :active.sync="loading"
                    :can-cancel="false"
                    :is-full-page="true"
            ></loading>
        </div>
        <div class="divSubtitulo d-flex justify-content-between">
            <p class="textSubtitulo">{{ titulo }}</p>
            <p class="textSubtituloCodigo">{{ codigo }}</p>
        </div>
        <!-- ------------------------------ -->
        <!-- ------------------------------ -->
        <b-tabs v-if="!loading" v-model="tabIndex" class="mt-3">
            <b-tab :title="subtitulo" active>
                <b-row v-if="!noTienePti && !detalle">
                    <b-col>
                        <h3>
                            El paciente ya cuenta con una solicitud de Hdx.
                        </h3>
                    </b-col>
                </b-row>
                <b-container v-else fluid class="text-left">
                  <b-row v-if="borradorExistente">
                    <b-col class="text-end">
                      <span class="badge-amarillo"  v-b-tooltip.hover.v-light.topright="'Complete la Hdx \n para guardarla'">HDx temporal (Borrador) </span>
                    </b-col>
                  </b-row>
                  <b-row v-if="existeRechazoDesentralizado">
                    <b-col class="text-end">
                      <span class="badge-rojo"  v-b-tooltip.hover.v-light.topright="'Pti Rechazado'">Rechazo pti og </span>
                    </b-col>
                  </b-row>
                    <b-row>
                        <b-col class="borde-azul" md="7" sm="12">
                            <b-row class="mb-2">
                              <b-col>
                                <div class="subcategoria"> Información del diagnóstico</div>
                              </b-col>
                              <b-col>
                                <b-badge  pill variant="success" style="padding: 10px;"  v-if="!bloquearformularioTag">Tag de cita: {{ obtenerDescTagMotivoCita() }}</b-badge >
                                <div v-else style="display: flex;">
                                  <b-badge  pill variant="success" style="padding: 10px;" class="mr-1">Motivo Cita:</b-badge>
                                  <b-form-select
                                      class="parrafos"
                                      :state="validateState('idTagMotivoCita')"
                                      size="sm parrafos"
                                      v-model="$v.formulario.idTagMotivoCita.$model"
                                      :disabled="!bloquearformularioTag || disable"
                                  >
                                    <b-form-select-option
                                        v-for="elem in tagmotivocitaDatosArrayOriginal"
                                        :key="elem.idTagMotivoCita"
                                        :value="elem.idTagMotivoCita"
                                    >{{ elem.descripcionTagMotivoCita }}
                                    </b-form-select-option>
                                  </b-form-select>
                                </div>
                              </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-row>
                                        <b-col><label>Fecha Solicitud: </label></b-col>
                                        <b-col>
                                            <span class="inf">{{ formulario.fechaSolicitud | formatoFechaHora }}</span>
                                        </b-col>
                                    </b-row>

                                </b-col>
                                <b-col v-if="$localStorageService.can('Bt_Bloquear_motivicita')">
                                    <b-form-checkbox name="check-button"
                                                     :disabled="disable"
                                                     v-model="bloquearformularioTag"
                                                     switch>
                                        <label>Restablecer motivo cita</label>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6" sm="12">
                                    <b-row>
                                        <b-col><label>Clinica: </label></b-col>
                                        <b-col><span class="inf">{{ formulario.clinica }}</span></b-col>
                                    </b-row>

                                </b-col>
                                <b-col md="6" sm="12">
                                    <template v-if="pantallaCdx">
                                        <label>Nivel pti: </label> <span class="inf">{{ formulario.nivelPti }}</span>
                                    </template>
                                    <template v-if="detalle">
                                        <label>Nivel pti: </label> <span class="inf">{{ formulario.nivelPti }}</span>
                                    </template>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6" sm="12">
                                    <b-row>
                                        <b-col><label>OG: </label></b-col>
                                        <b-col><span class="inf">{{ formulario.empleado }}</span></b-col>
                                    </b-row>

                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-row>
                                        <b-col>
                                            <template v-if="pantallaCdx">
                                                <label>Diagnosticador: </label>
                                            </template>
                                            <template v-if="detalle">
                                                <br>
                                                <template v-if="idPtiCdx === undefined || idPtiCdx === null">
                                                    <label>Embajador: </label>
                                                </template>
                                                <template v-else>
                                                    <label>Validador: </label>
                                                </template>
                                            </template>
                                        </b-col>
                                        <b-col>
                                            <template v-if="pantallaCdx">
                                                <span class="inf">{{
                                                    formulario.diagnosticador
                                                    }}</span>
                                            </template>
                                            <template v-if="detalle">
                                                <br>
                                                <template v-if="idPtiCdx === undefined || idPtiCdx === null">
                                                    <span class="inf">{{ formulario.embajador }}</span>
                                                </template>
                                                <template v-else>
                                                    <span class="inf">{{ formulario.validador }}</span>
                                                </template>
                                            </template>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="6" sm="12">
                                    <label>Toma de Herramientas:</label>
                                    <v-select
                                            v-model="$v.formulario.idKit.$model"
                                            :options="kits" :disabled="disable"

                                            :class="selectClass('idKit')"
                                            label="descripcion"
                                            :reduce="(i) => i.id"
                                    ></v-select>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <label>Medicamentos y/o Tratamientos realizados recientemente</label>
                                    <b-form-textarea
                                            class="form-control"
                                            :disabled="disable"
                                            :state="validateState('informacionPaciente')"
                                            placeholder="Medicamentos y/o Tratamientos realizados recientemente"
                                            aria-label="With textarea"
                                            v-model="$v.formulario.informacionPaciente.$model"
                                    ></b-form-textarea>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="borde-azul" style="margin-top: 1rem; max-height: 24rem; overflow-y: auto">
                            <div class="subcategoria">Herramientas</div>
                            <carrusel-herramientas ref="carrusel" v-if="id_Paciente!=null" :id-paciente="id_Paciente"
                                                   @irTabExpediente="irTabExpediente"></carrusel-herramientas>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" class="borde-azul">
                            <b-col>
                                <div class="subcategoria mb-3">Salud del paciente</div>
                                <b-row cols="1" cols-sm="2" cols-md="3" cols-lg="3">
                                    <b-col v-for="(item, i) in enfermedades" :key="'clasificacion'+i">
                                        <div class="subcategoria" style="color: var(--card-bordes) !important;">
                                            {{ item.nombre }}
                                        </div>
                                        <b-form-group
                                                v-slot="{ ariaDescribedby }"
                                        >
                                            <b-form-checkbox-group
                                                    v-model="$v.formulario.enfermedadSistemicas.$model"
                                                    :options="item.enfermedades"
                                                    :state="validateState('enfermedadSistemicas')"
                                                    :disabled="disable"
                                                    value-field="idEnfermedadSistemica"
                                                    text-field="descripcionEnfermedad"
                                                    :aria-describedby="ariaDescribedby"
                                                    name="flavour-2a"
                                                    stacked
                                            ></b-form-checkbox-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>

                            </b-col>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="borde-azul">
                            <b-row class="mb-3" v-if="id_denticion === 1 || id_denticion ===3">
                                <b-col md="3" sm="12">
                                    <div class="subcategoria mb-3">Salud dental</div>
                                    <label>Tipo de odontograma</label>
                                    <b-form-select
                                            :disabled="disable"
                                            v-model="id_denticion"
                                            text-field="descripcion"
                                            value-field="id"
                                            :options="denticiones"
                                    >
                                    </b-form-select>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="3" sm="12">
                                    <b-row v-if="id_denticion === 2 || id_denticion ===3">
                                        <b-col>
                                            <div class="subcategoria">Odontograma Adulto</div>
                                            <odontograma :disable="disable" :dientesSeleccionados="dientesSeleccionados" :multiplesDientesSeleccionados="multiplesDientesSeleccionados" :multiplesODS="multiplesODS"
                                                         @dienteSeleccionado="dienteSeleccionado" @multiplesODSeleccionado="multiplesODSeleccionado"/>
                                        </b-col>
                                    </b-row>
                                    <b-row v-if="id_denticion === 1 || id_denticion ===3">
                                        <b-col>
                                            <div class="subcategoria">Odontograma Niño</div>
                                            <odontograma-nino :dientesSeleccionados="dientesSeleccionados"
                                                              @dienteSeleccionado="dienteSeleccionado"/>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-3">
                                        <b-col>
                                            <font-awesome-icon class="diente" :icon="['fas', 'circle']"/>
                                            OD
                                        </b-col>
                                        <b-col>
                                            <font-awesome-icon class="cuadrante" :icon="['fas', 'circle']"/>
                                            Cuadrante
                                        </b-col>
                                        <b-col>
                                            <font-awesome-icon class="maxilares" :icon="['fas', 'circle']"/>
                                            Maxilar
                                        </b-col>
                                    </b-row>

                                </b-col>
                                <b-col>
                                    <b-row>
                                        <loading :active.sync="load" :can-cancel="false" :is-full-page="true"></loading>
                                        <b-col>
                                            <div class="subcategoria">Órganos dentales seleccionados</div>
                                        </b-col>
                                        <b-col v-if="!loaderData" class="text-end">
                                            <b-button v-b-tooltip.hover.v-light.topright="'Agregar múltiples OD´S'"
                                                      variant="ligth" class="button-circle shadow mr-3 text-dentalia"
                                                      @click="agregarODS()">
                                                      <font-awesome-icon :icon="['fas', 'plus']"/>
                                            </b-button>
                                            <b-button  v-if="!detalle && id_denticion === 2" v-b-tooltip.hover.v-light.topright="'Ordenar ODs'"
                                                      variant="ligth" class="button-circle shadow mr-3 text-dentalia"
                                                      @click="ordenarODS()">
                                                <em class="ordenarDiente" style="width: 100%; height: 100%; margin-left: 1px; margin-bottom: 0%;"></em>
                                            </b-button>
                                            <b-button  v-if="!detalle" v-b-tooltip.hover.v-light.topright="'Seleccionar todo'"
                                                      variant="ligth" class="button-circle shadow mr-3 text-dentalia"
                                                      @click="seleccionarTodo()">
                                                <font-awesome-icon :icon="['fas', 'check-square']"/>
                                            </b-button>
                                            <b-button v-if="!detalle && !descentralizado" v-b-tooltip.hover.v-light.topright="'Eliminar'" variant="ligth"
                                                      class="button-circle shadow mr-3 text-dentalia"
                                                      @click="eliminarVarios()">
                                                <font-awesome-icon :icon="['fas', 'trash-alt']"/>
                                            </b-button>
                                            <b-button size="sm"
                                                    variant="ligth"
                                                    class="button-circle shadow mr-3 text-dentalia"
                                                    v-if="descentralizado">
                                                <b-dropdown
                                                    v-b-tooltip.hover
                                                    title="Eliminar"
                                                    size="sm"
                                                    variant="ligth"
                                                >
                                                <template #button-content>
                                                    <font-awesome-icon style="color: #0069aa" :icon="['fas', 'trash-alt']"/>
                                                </template>
                                                    <b-form-group v-slot="{ ariaDescribedby }" class="ml-2 mt-2">
                                                        <b-form-radio-group
                                                            v-model="selected"
                                                            :aria-describedby="ariaDescribedby"
                                                            name="eliminar"
                                                            stacked
                                                        >
                                                            <b-form-radio @change="validacionEliminar()" value="ods">OD'S</b-form-radio>
                                                            <b-form-radio @change="validacionEliminar()" value="tratamientos">Tratamientos</b-form-radio>
                                                            <b-form-radio @change="validacionEliminar()" class="ml-4" value="1">PTI I</b-form-radio>
                                                            <b-form-radio @change="validacionEliminar()" class="ml-4" value="2">PTI II</b-form-radio>
                                                            <b-form-radio @change="validacionEliminar()" class="ml-4" value="3">PTI III</b-form-radio>
                                                    </b-form-radio-group>
                                                    </b-form-group>
                                                    <b-button variant="outline-primary" style="margin-left: 30%;" size="sm" @click="eliminarVarios()">Eliminar</b-button>
                                                    
                                                </b-dropdown>
                                            </b-button>
                                            
                                            <b-button v-b-tooltip.hover.v-light.topright="'Mostrar todo'"
                                                      variant="ligth" class="button-circle shadow mr-3 text-dentalia"
                                                      @click="desplegar()">
                                                <font-awesome-icon :icon="['fas', 'angle-double-down']"/>
                                            </b-button>
                                            <b-button v-b-tooltip.hover.v-light.topright="'Ocultar todo'"
                                                      variant="ligth" class="button-circle shadow mr-3 text-dentalia"
                                                      @click="ocultar()">
                                                <font-awesome-icon :icon="['fas', 'angle-double-up']"/>
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                    <b-col style="overflow: auto;max-height: 100vh; min-height: 100vh"
                                           :style=" id_denticion === 3 ? 'max-height: 200vh': 'max-height: 100vh'"
                                           v-if="!loaderData">
                                        <b-form-invalid-feedback :state="validateState('dientes')">
                                            Debe agregar el padecimiento
                                        </b-form-invalid-feedback>
                                        <div v-if="formulario.dientes.length === 0 && multiplesODS == false"
                                             class="text-center align-items-center flex--wrap" style="margin-top: 12%;">
                                            <img width="150" src="../../assets/icons/no-result.png">
                                            <p class="txt-not-found text-center">No se encontraron dientes
                                                seleccionados</p>
                                        </div>
                                        <div v-if="multiplesODS == false">
                                            <div v-for="(diente,i) in formulario.dientes" :key="diente.diente.diente">
                                                <HDXPadecimientos
                                                    :statePadecimiento="selectClassArray('dientes',i,'padecimiento')"
                                                    :stateValidate="validateStateArray('dientes',i,'padecimiento')"
                                                    :diente="diente"
                                                    :index="i"
                                                    :descentralizado="descentralizado"
                                                    :detalle="detalle"
                                                    :disable="disable"
                                                    :id-tag-motivo-cita="formulario.idTagMotivoCita"
                                                    :id-denticion="id_denticion"
                                                    :id-clinica="formulario.idClinica"
                                                    :idPaciente="id_Paciente"
                                                    :idEmpleado="formulario.idEmpleado"
                                                    @eliminarDiente="eliminarDiente"
                                                    @rutaClinica="rutaClinica"
                                                    @actualizarPadsAddNoReq="actualizarPadsAddNoReq"
                                                ></HDXPadecimientos>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <MultiplesODS
                                                :diente="formulario.dientes"
                                                :multiplesDientes="multiplesDientes"
                                                :descentralizado="descentralizado"
                                                :detalle="detalle"
                                                :disable="disable"
                                                :id-tag-motivo-cita="formulario.idTagMotivoCita"
                                                :id-denticion="id_denticion"
                                                :id-clinica="formulario.idClinica"
                                                :idPaciente="id_Paciente"
                                                :idEmpleado="formulario.idEmpleado"
                                                @cancelarMultiple="cancelarMultiple"
                                                @eliminarDienteMultiple="eliminarDienteMultiple"
                                                @rutaClinica="rutaClinica"
                                                @actualizarPadsAddNoReq="actualizarPadsAddNoReq"
                                                @multiplesODSeleccionados="multiplesODSeleccionados"
                                            ></MultiplesODS>
                                        </div>
                                    </b-col>
                                    <b-col v-else></b-col>

                                </b-col>

                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="borde-azul">
                            <div class="subcategoria"> Ruta clínica</div>
                            <ruta :listaRuta="listaRuta"/>
                        </b-col>
                        <b-col cols="12" class="mt-3">
                          <div class="subcategoria" style="color: black">
                            Observaciones del OG
                            <div style="font-size: 10px" v-if="disable || pantallaCdx" >
                              {{ formulario.fechaSolicitud | formatoFechaHora }}
                            </div>
                          </div>
                          <div v-if="pantallaCdx" class="box-comentarios" style="padding-top: 0; font-size: 12px">
                            <span v-if="formulario.informacionDiagnosticaOG==null">
                              Sin observaciones
                            </span>
                            <span v-else>
                              {{formulario.informacionDiagnosticaOG}}
                            </span>
                          </div>
                          <b-form-textarea v-else
                                           class="form-control"
                                           :disabled="disable"
                                           :state="validateState('informacionDiagnosticaOG')"
                                           placeholder="Revisión del OG"
                                           aria-label="With textarea"
                                           v-model="$v.formulario.informacionDiagnosticaOG.$model"
                          ></b-form-textarea>
                        </b-col>
                        <b-col class="borde-azul">
                          <b-col cols="12">
                            <div class="subcategoria">
                                Observaciones del CDx
                              <div style="font-size: 10px" v-if="disable || !pantallaCdx" >
                                {{ formulario.fechaCDX | formatoFechaHora }}
                              </div>
                            </div>
                            <div v-if="!pantallaCdx" class="box-comentarios">
                              <span v-if="formulario.informacionDiagnostica==null">
                                  Sin observaciones
                                </span>
                              <span>{{formulario.informacionDiagnostica}}</span>
                            </div>
                            <b-form-textarea v-else
                                    class="form-control"
                                    :disabled="disable"
                                    :state="validateState('informacionDiagnostica')"
                                    placeholder="Revisión"
                                    aria-label="With textarea"
                                    v-model="$v.formulario.informacionDiagnostica.$model"
                            ></b-form-textarea>
                          </b-col>
                        </b-col>
                    </b-row>
                    <b-row v-if="!disable" style="padding-bottom: 0%;">
                        <b-col class="text-center">
                            <boton-cancelar variant="info" boton-text="Guardar" :loader="loader"
                                            loading-text="Guardando..."
                                            @accion="guardar()"></boton-cancelar>
                        </b-col>
                    </b-row>
                </b-container>
            </b-tab>
            <b-tab
                    title="Expediente digital"
            >
                <ExpedienteDigital v-if="id_Paciente!=null" :idPacienteExp="id_Paciente"></ExpedienteDigital>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import odontograma from "../../views/odontograma/Odontograma.vue";

import ExpedienteDigital from "@/views/ExpedienteDigitalPaciente/ExpedienteDigital";
import HDXPadecimientos from "@/views/odontograma/detalleDiagnostico/HDXPadecimientos";
import BotonCancelar from "@/components/BotonCancelar";
import {PtiPresuntivoService} from "@/apiServices/ptiPresuntivo/PtiPresuntivoService";
import {required} from "vuelidate/lib/validators";
import Ruta from '../../views/Ruta.vue';
import CarruselHerramientas from "@/components/hojasDiagnostico/carruselHerramientas";
import OdontogramaNino from "@/views/odontograma/OdontogramaNino";
import {PacienteService} from "@/apiServices/paciente/PacienteService";
import {MotorService} from "@/apiServices/motor/MotorService";
import MultiplesODS from "@/views/odontograma/detalleDiagnostico/MultiplesODS";

export default {
    components: {
        OdontogramaNino,
        CarruselHerramientas,
        BotonCancelar,
        HDXPadecimientos,
        ExpedienteDigital,
        odontograma,
        Ruta,
        MultiplesODS,
    },
    props: {
        titulo: String,
        subtitulo: String,
        codigo: String,
        idPaciente: Number,
        idPtiCdx: String,
        idSesionSeleccionada: Number,
        doctores: Array,
        idDenticion: Number,
        esSdi: Boolean,
        detalle: Boolean,
        descentralizado: {
          type: Boolean,
          default: true
        },
        existeRechazoDesentralizado: {
          type: Boolean,
          default: false
        },
      etapaRechazo: Number,
      solicitudRechazo: Number,
      vecesRechazo: Number,
    },
    data() {
        return {
          version: process.env.VUE_APP_ENV_VERSION,
          debug: false,
            ptiPrsuntivoServicio: new PtiPresuntivoService(),
            pacienteServicio: new PacienteService(),
            motorServicio: new MotorService(),
            formulario: {
                fechaSolicitud: new Date(),
                idClinica: null,
                clinica: null,
                idEmpleado: null,
                empleado: null,
                diagnosticador: null,
                embajador: null,
                idFlujoPx1: null,
                idTagMotivoCita: null,
                enfermedadSistemica: null,
                idKit: null,
                tomaHerramienta: false,
                candidatoOrtodoncia: false,
                informacionPaciente: null,
                informacionDiagnostica: null,
                informacionDiagnosticaOG: null,
                habitos: null,
                bruxismo: false,
                placaSarro: false,
                periodontitis1: false,
                periodontitis2: false,
                periodontitis3: false,
                periodontitis4: false,
                dientes: [],
                enfermedadSistemicas: []
            },

            loading: false,
            loader: false,

            kits: [],
            tagCitaOriginal: null,
            tipoTagDatosArray: [],
            tagmotivocitaDatosArray: [],
            bloquearformularioTag: false,

            tagmotivocitaDatosArrayOriginal: [],

            dientesSeleccionados: [],
            multiplesDientesSeleccionados: [],
            idSesionSeleccionadaHDX: null,

            idPti: null,
            idEtapa: null,
            idSolicitudEtapa: null,

            id_Paciente: null,
            id_denticion: null,
            noTienePti: true,
            loaderData: false,

            listaRuta: [
                [],
                [],
                []
            ],
            listaBocaCompleta: [],
            listaCuadrante: [],
            listaSuperior: [],
            listaInferior: [],
            enfermedades: [],
            denticiones: [],
            pantallaCdx: false,
            rutaRadiografia: '',
            tabIndex: 0,
            idEstatus: null,
            disable: false,
            activo: false,
            todo: false,
            grupo: null,
            idGrupo: false,
            tituloModalHerramientas: null,
            parrafoHerramienta: null,
            bagesHerramienta: null,
            tituloBotonAceptar: null,
            imagenModalBase64: null,
            listaHerramientasFaltantes: "",
            borrador: false,
            borradorExistente: false,
            colorButtonConfirmar: null,
            tituloBotonCancelar: null,

            selected: null,
            multiplesODS: false,
            multiplesDientes: [],

            nivelPTI: null
        }
    },
    validations: {
        formulario: {
            fechaSolicitud: {},
            idClinica: {},
            clinica: {},
            idEmpleado: {},
            empleado: {},
            idFlujoPx1: {},
            idTagMotivoCita: {required},
            idKit: {required},
            tomaHerramienta: {},
            candidatoOrtodoncia: {required},
            informacionPaciente: {required},
            informacionDiagnostica: {},
            informacionDiagnosticaOG: {},
            dientes: {
                required,
                $each: {
                    padecimiento: {required}
                }
            },
            enfermedadSistemicas: {},

        }
    },
  created() {
    this.debug = this.$localStorageService.getDebug();
        this.id_Paciente = this.idPaciente
        this.id_denticion = this.idDenticion


        this.idPti = this.$route.params.id
        this.idEtapa = this.$route.params.idEtapa
        this.idSolicitudEtapa = this.$route.params.idSolicitudEtapa
        this.formulario.idSesion = this.idSesionSeleccionada;




        if (this.idEtapa !== undefined && this.idEtapa !== null) {
            this.obtenerInformacionHDXPti()
            this.estatusEtapa();
            this.pantallaCdx = true;
        } else if (this.idPtiCdx !== undefined && this.idPtiCdx !== null) {
            this.obtenerInformacionCDX()
            this.disable = true
        } else if (this.detalle) {
            this.obtenerInformacionHDX(true)
            this.disable = true
        } else if (this.existeRechazoDesentralizado){
          this.obtenerInformacionHDX(this.vecesRechazo > 1 ? false : true )
          this.disable = false;
          this.noTienePti = true;
          this.detalle = true;
        }
        else{
            this.existePti()
            this.obtenerBorrador();
            this.pantallaCdx = false;
            this.tagMotivoCita()
            this.tagSeleccionadoEnLaCita()
            this.obtenerDentticion()
        }

        this.obtenerDiagnosticador();

        //tiene que ir primero para cargar la sesion


        this.formulario.idEmpleado = this.$localStorageService.getIdEmpleado();
        this.formulario.empleado = this.$localStorageService.getNombreCompletoUsuario();
        this.formulario.clinica = this.$localStorageService.getNombreClinica();
        this.formulario.idClinica = this.$localStorageService.getIdClinica();

        this.obtenerkits()
        this.obtenerEnfermedades()
        this.obtenerRutaRadiografia();



    },
    methods: {
        estatusEtapa() {
          const params = {
            idSolicitudEtapa: this.idSolicitudEtapa
          }
            this.motorServicio.obtenerEstatusSolicitudEtapa(params)
                .then(
                    res => {
                        this.idEstatus = res
                        if (this.idEstatus == 3) {
                            this.disable = true
                        }
                    }
                )
        },
        obtenerEnfermedades() {
            this.pacienteServicio.obtenerEnfermedades()
                .then(res => {
                    this.enfermedades = res
                })
        },
        existePti() {
            const parametros = {idPaciente: this.idPaciente}
            this.$http
                .post(this.$api + "pti/existePtiMayor6Meses", parametros)
                .then((response) => {
                    this.noTienePti = response.data.data;
                })
                .catch((error) => {
                    console.error(
                        "Error al obtener la validación de existencia de un pti del  del paciente: " +
                        error
                    );
                })

        },

        padecimientosAdicionales() {
            const params = {
                denticion: this.id_denticion, 
                tagMotivoCita: this.formulario.idTagMotivoCita
            }
            this.$http
                .post(this.$api + "catalogos/padecimientos/obtener/denticion/descentralizada/arcada-boca", params)
                .then((res) => {

                    const data = res.data.data
                    this.listaBocaCompleta = data.bocaCompleta;
                    this.listaCuadrante = data.cuadrante;
                    this.listaInferior = data.inferior;
                    this.listaSuperior = data.superior;

                })
        },
        obtenerInformacionHDX(originales) {
            const parametros = {idPaciente: this.id_Paciente, originales: originales}
            this.ptiPrsuntivoServicio.obtenerInformacionHDX(parametros).then(
                response => {
                    this.formulario = Object.assign({}, response);
                    if (!this.formulario.diagnosticador) {
                        this.formulario.diagnosticador = this.$localStorageService.getNombreCompletoUsuario();
                    }
                    this.dientesSeleccionados = this.formulario.dientes.map(d => d.diente);
                    this.formulario.dientes.forEach(d => d.buscar = false);
                    this.tagCitaOriginal = this.formulario.idTagMotivoCita
                    this.id_Paciente = response.idPaciente
                    this.id_denticion = response.idDenticion

                    this.tagMotivoCita()
                    this.rutaClinica()
                    this.obtenerDentticion()
                    this.padecimientosAdicionales();
                }
            ).finally(
                () => {
                    this.loader = false
                }
            )
        },
        /*obtenerEnfermedadesSistemicas() {
            this.ptiPrsuntivoServicio.obtenerEnfermedades(this.id_Paciente).then(
                response => {
                    this.formulario.enfermedadSistemicas = response
                }
            ).finally(
                () => {
                    this.loader = false
                }
            )
        },*/
        obtenerInformacionCDX() {
            const parametros = {idPti: this.idPtiCdx}
            this.ptiPrsuntivoServicio.obtenerInformacionCDX(parametros).then(
                response => {
                    this.formulario = Object.assign({}, response);
                    if (!this.formulario.diagnosticador) {
                        this.formulario.diagnosticador = this.$localStorageService.getNombreCompletoUsuario();
                    }
                    this.dientesSeleccionados = this.formulario.dientes.map(d => d.diente);
                    this.formulario.dientes.forEach(d => d.buscar = false);
                    this.tagCitaOriginal = this.formulario.idTagMotivoCita
                    this.id_Paciente = response.idPaciente
                    this.id_denticion = response.idDenticion
                    this.tagMotivoCita()
                    this.rutaClinica()
                    this.obtenerDentticion()
                    this.padecimientosAdicionales();
                }
            ).finally(
                () => {
                    this.loader = false
                }
            )
        },
        obtenerInformacionHDXPti() {
            this.loaderData = true;
            const parametros = {idPti: this.idPti}
            this.ptiPrsuntivoServicio.obtenerInformacionHDXPti(parametros).then(
                response => {
                    this.formulario = Object.assign({}, response);
                    if (!this.formulario.diagnosticador) {
                        this.formulario.diagnosticador = this.$localStorageService.getNombreCompletoUsuario();
                    }
                    this.dientesSeleccionados = this.formulario.dientes.map(d => d.diente);
                    this.formulario.dientes.forEach(d => d.buscar = false);
                    this.id_Paciente = response.idPaciente
                    this.id_denticion = response.idDenticion
                    this.tagCitaOriginal = this.formulario.idTagMotivoCita
                    this.tagMotivoCita()
                    this.rutaClinica()
                    this.obtenerDentticion()
                    this.padecimientosAdicionales();
                    this.$emit('idPaciente', this.formulario.idPaciente)
                    if (this.detalle) {
                        this.disable = true
                    }
                }
            ).finally(
                () => {
                    this.loaderData = false;
                    this.obtenerUltimaSesionActivaConSinTomadeHerramientas();
                }
            )
        },
        obtenerkits() {
            this.ptiPrsuntivoServicio.obtenerkits().then(
                response => {
                    this.kits = response;
                }
            )
        },
        obtenerDentticion() {
            const params = {
              idPaciente: this.id_Paciente
            }
            this.ptiPrsuntivoServicio.obtenerDentticion(params).then(
                response => {
                  this.id_denticion = response[0].id
                    this.denticiones = response;
                }
            )
        },

        obtenerUltimaSesionActivaConSinTomadeHerramientas() {
            const parametros = {idPaciente: this.id_Paciente, tomaHerramientas: this.esSdi}
            this.$http
                .post(
                    this.$api +
                    "sesion/obtenerultimasesionactivaconsintomadeherramientas", parametros
                )
                .then((response) => {
                    this.idSesionSeleccionadaHDX = response.data.data.idSesion;
                });
        },
        tagSeleccionadoEnLaCita() {
            this.tagSeleccionadoEnLaCitaArray = [];
            const params = {
                idSesion: this.formulario.idSesion
            }
            this.$http
                .post(
                    this.$api +
                    "tagmotivocita/poridsesion", params
                )
                .then((response) => {
                    this.tagSeleccionadoEnLaCitaArray = response.data.data;

                    if (this.tagSeleccionadoEnLaCitaArray.idTagMotivoCita != null) {
                        this.formulario.idTagMotivoCita = this.tagSeleccionadoEnLaCitaArray.idTagMotivoCita;
                        this.tagCitaOriginal = this.tagSeleccionadoEnLaCitaArray.idTagMotivoCita;
                        this.padecimientosAdicionales();
                        this.formulario.idFlujoPx1 = this.tagSeleccionadoEnLaCitaArray.idTipoTag;
                        this.tagMotivoCita();

                        //si es un motivo de dolor/urgencia no aplica hoja de diagnostico
                        if (
                            this.tagSeleccionadoEnLaCitaArray.idTagMotivoCita == 6 ||
                            this.tagSeleccionadoEnLaCitaArray.idTagMotivoCita == 13
                        ) {
                            this.mostrarFormulario = false;
                            this.mensajeMotivoCita =
                                "No se puede generar un pti con un paciente de emergencia";
                        }

                    }
                });
        },
        tagMotivoCita() {
            this.tagmotivocitaDatosArrayOriginal = [];

            this.$http
                .get(
                    this.$api +
                    "tagmotivocita/tagmotivocita"
                )
                .then((response) => {
                    this.tagmotivocitaDatosArrayOriginal = response.data.data.filter(r => r.idTipoDenticion === this.id_denticion);
                })
                .finally(() => {
                });
        },
        dienteSeleccionado(data) {
            this.diente = data.diente;
            this.dientesSeleccionados = data.dientes;
            if (data.diente.idDiente != 137) {
                const i = this.formulario.dientes.map(d => d.diente.idDiente).indexOf(this.diente.idDiente)
                if (i > -1) {
                    // this.formulario.dientes.splice(i,1)
                    this.$swal.fire({
                        icon: "error",
                        title: "<span style='font-size: medium'>upps, no se puede agregar otro \n padecimiento a este diente</span>",
                        text: "pero no te preocupes, intenta con otro diente",
                        customClass: {
                            confirmButton: "text-small",
                            content: "text-small",
                        }
                    });
                    return;
                }
            }
                this.formulario.dientes.unshift({
                    diente: this.diente,
                    buscar: true,
                    seleccionar: false,
                    visible: this.activo,
                    padecimiento: null,
                    tratamientos: []
                });
        },

        multiplesODSeleccionado(data) {
            this.diente = data.diente;
            if (data.diente.idDiente != 137) {
                const i = this.multiplesDientes.map(d => d.idDiente).indexOf(this.diente.idDiente)
                if (i > -1) {
                    this.$swal.fire({
                        icon: "error",
                        title: "<span style='font-size: medium'>upps, no se puede agregar otro \n padecimiento a este diente</span>",
                        text: "pero no te preocupes, intenta con otro diente",
                        customClass: {
                            confirmButton: "text-small",
                            content: "text-small",
                        }
                    });
                    return;
                }
            }
            this.multiplesDientes.unshift(this.diente);
        },
        
        multiplesODSeleccionados(data) {
            this.multiplesODS = false;
            this.load = true;
            setTimeout(() => {
                data.dientes.forEach(md => {
                    this.formulario.dientes.unshift({
                        diente: md,
                        buscar: true,
                        seleccionar: false,
                        visible: false,
                        padecimiento: JSON.parse(JSON.stringify(data.padecimiento)),
                        tratamientos: []
                    });
                    this.dientesSeleccionados.unshift(md);
                });
                this.load = false;
            }, 1000);
        },

        eliminarDietePorIndex(item) {
            this.formulario.dientes.splice(item, 1)
            this.dientesSeleccionados = this.formulario.dientes.map(d => d.diente);
            this.rutaClinica();

        },
        eliminarDiente(item) {
            const index = this.formulario.dientes.indexOf(item);
            this.formulario.dientes.splice(index, 1)
            this.dientesSeleccionados = this.formulario.dientes.map(d => d.diente);

            this.rutaClinica();

        },

        eliminarDienteMultiple(item) {
            var dientes = this.multiplesDientesSeleccionados;
            const index = dientes.indexOf(item);
            dientes.splice(index, 1)
            this.multiplesDientesSeleccionados = dientes;
        },

        limpiarChecks(item) {
            this.listaBocaCompleta.forEach(i => {
                if (item.padecimiento.idPadecimiento === i.padecimiento.idPadecimiento) {
                    i.idPadecimiento = false;
                }
            })

            this.listaCuadrante.forEach(i => {
                if (item.padecimiento.idPadecimiento === i.padecimiento.idPadecimiento) {
                    i.idPadecimiento = false;
                }
            })

            this.listaSuperior.forEach(i => {
                if (item.padecimiento.idPadecimiento === i.padecimiento.idPadecimiento) {
                    i.idPadecimiento = false;
                }
            })

            this.listaInferior.forEach(i => {
                if (item.padecimiento.idPadecimiento === i.padecimiento.idPadecimiento) {
                    i.idPadecimiento = false;
                }
            })

        },
        obtenerRutaRadiografia() {
            const params = {
                idRutaPadre: 5
            }
            this.$http
                .post(this.$api + "rutaExpediente/listarRutasHijas", params)
                .then((response) => {
                    for (let index = 0; index < response.data.data.length; index++) {
                        if (response.data.data[index].idRuta === 6) {
                            this.rutaRadiografia = response.data.data[index].path;
                        }
                    }
                    this.rutaRadiografia = this.rutaRadiografia.replace(
                        "#id_paciente",
                        this.idPaciente
                    );
                });
        },
        async herramientasCompletas() {
            return await this.$http.get(
                this.$api + "rutaExpediente/validacionHerramientasCompletas?rutaDirectorio=" + this.rutaRadiografia
                + "&idClinica=" + this.$localStorageService.getIdClinica()
                + "&tipo=" + 1
            );
        },
      async vadicionActivarEceClinica() {
        const params = {
            idFlujo: 1,
            idPaciente: this.id_Paciente, 
            idClinica: this.$localStorageService.getIdClinica()
        }
        return await this.$http.post(
            this.$api + "herramientaExpedienteElectronico/obtenerHerramientasFaltantes", params 
        );
      },
        async guardar() {
            if(this.formulario.idTagMotivoCita == 6 || this.formulario.idTagMotivoCita == 13){
                this.$swal.fire({
                    title:
                        "<strong>Para emitir el PTI debes de cambiar el motivo de cita a uno que no sea Dolor/Urgencia</strong>",
                    focusConfirm: false,
                    icon: "warning",
                    confirmButtonText: "ok",
                    customClass: {
                        confirmButton: "btn-success",
                    },
                })
                return;
            }
          this.$v.formulario.$touch();
          if (this.$v.formulario.$anyError) {
            return;
          }
          this.loader = true;
          const rep = await this.vadicionActivarEceClinica();
          const numeroHerramientas = rep.data.data.length;
          if (!this.$v.formulario.$invalid && rep.data.data && this.idGrupo == false && rep.data.message != 'Expediente Clinico Electronico esta desactivado') {
            this.listaHerramientasFaltantes = "";
            if(rep.data.data.length === 0){
              this.imagenModalBase64 = "data:image/png;base64,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";
              this.bagesHerramienta = '<div><span class="badge badge-success">Herramientas Completas</span></div>';
              this.tituloModalHerramientas = '<span class="mt-4" style="font-weight:600; font-size: 20px">¿Estás seguro de que quieres continuar?</span></br>';
              this.parrafoHerramienta = '<span class="mt-5" style="font-weight:600; color: #e98918; font-size: 17px">Una vez que se envié la hoja de diagnóstico, no se podrán hacer</br>' +
                  ' cambios</span>';
              this.tituloBotonAceptar = 'Si, continuar';
              this.tituloBotonCancelar = 'No, cancelar'
              this.colorButtonConfirmar = '#e98918';
              this.borrador = false;
            }else if (rep.data.data.length > 0 && rep.data.message !== "Expediente Clinico Electronico esta desactivado"){
              this.imagenModalBase64 = "data:image/png;base64,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"
              this.bagesHerramienta = '<div><span class="badge badge-danger">'+rep.data.message+'</span></div>';
              this.tituloModalHerramientas = '<span class="mt-4" style="font-weight:600; font-size: 20px">Para continuar debes de cargar las herramientas: </span></br></br></br></br>';
              this.parrafoHerramienta = '<span class="mt-5" style="font-weight:600; color: #C31C1C; font-size: 17px">¿Deseas guardar tu hoja de diagnóstico como borrador?</br>' +
                  'Podrás acceder cuando quieras</span>';
              this.tituloBotonAceptar = 'Guardar como borrador';
              this.tituloBotonCancelar = 'Cancelar'
              this.colorButtonConfirmar = '#C31C1C';
              this.borrador = true;
              rep.data.data.forEach((h)=>{
                this.listaHerramientasFaltantes += "<li style='list-style: disc !important;'><strong>"+h.cantidadArchivoFalta+" "+h.herramientasECEDTO.nombreHerramienta+"</strong></li>"
              })
              this.listaHerramientasFaltantes = "<ul>"+this.listaHerramientasFaltantes+"</ul>"
            }
            this.$swal.fire({
              width: '700px',
              html:'<div class="container-fluid cew-9"> ' +
                  this.bagesHerramienta+
                  '<img class="mt-3" src="'+this.imagenModalBase64+'"></br>'+
                  ' <div class="row justify-content-center">' +
                  this.tituloModalHerramientas+
                  this.listaHerramientasFaltantes+
                  this.parrafoHerramienta+
                  ' </div>' +
                  '</div>',
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: this.tituloBotonAceptar,
              confirmButtonColor: this.colorButtonConfirmar,
              cancelButtonColor: "#595959",
              cancelButtonText: this.tituloBotonCancelar,
              customClass: {
                confirmButton: 'rounded-pill',
                cancelButton: 'rounded-pill'
              }
            }).then((result) => {
              if (result.isConfirmed && !this.borrador) {
                if (this.idEtapa !== undefined && this.idEtapa !== null) {
                  this.guardarValidacion()
                } else {
                  this.formulario.tomaHerramienta = true;
                  this.$swal
                      .fire({
                        title:
                            "<strong>¿Estás seguro de generar el PTI?</strong>",
                        focusConfirm: false,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Sí",
                        cancelButtonText: "No",

                        customClass: {
                          confirmButton: "btn-success",
                          cancelButton: "btn-danger",
                        },
                      })
                      .then((result) => {
                        if (result.isConfirmed) {
                          this.obtenerNivel();
                        }
                      })
                }
              }
              if (result.isConfirmed && this.borrador) {
               this.guardarBorrador(numeroHerramientas);
              }
            })
          }else{
            this.guardadoAnterior();
          }

        },
      guardadoAnterior(){
        var bandera = false;
        var sinTrt = false;
        var txt = "";
        this.$v.formulario.$touch();
        if (this.$v.formulario.$anyError) {
          return;
        }

        this.datos(false, false).dientes.forEach(element => {
            var checkColumnUno = false;
            var checkColumnDos = false;
            var checkColumnTres = false;
            var banderavalidacion = element.padecimiento.validacion
                ? element.padecimiento.validacion
                : false;
            if(banderavalidacion){
                element.tratamientos[0].forEach(trat => {
                    if(trat.idTratamiento != null){
                        checkColumnUno = true;
                    }
                });
                element.tratamientos[1].forEach(trat => {
                    if(trat.idTratamiento != null){
                        checkColumnUno = true;
                    }
                });
                element.tratamientos[2].forEach(trat => {
                    if(trat.idTratamiento != null){
                        checkColumnUno = true;
                    }
                });
                if (
                    checkColumnUno == false &&
                    checkColumnDos == false &&
                    checkColumnTres == false
                ) {
                    sinTrt = true;
                    txt = element.diente.diente == 0 ? "SUPERNUMERARIO" : element.diente.diente;
                }
            }
        });

        if (!this.$v.formulario.$invalid) {
          if (this.pantallaCdx === false) {
            if(sinTrt){
                this.loader = false;
                this.$swal.fire({
                    icon: "info",
                    title: "Falta agregar tratamientos",
                    text: "El diente " + txt + " No cuenta con 1 tx.",
                }); 
                return;
            }else{
                this.$swal
                .fire({
                  title:
                      "<strong>¿Tu paciente ya cuenta con Toma de Herramientas?</strong>",
                  focusConfirm: false,
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Sí",
                  cancelButtonText: "No",

                  customClass: {
                    confirmButton: "btn-success",
                    cancelButton: "btn-danger",
                  },
                })
                .then((result) => {

                  if (result.isConfirmed) {
                    this.formulario.tomaHerramienta = true;
                  }

                  this.$swal
                      .fire({
                        title:
                            "<strong>¿Estás seguro que haz terminado la validación del pti?</strong>",
                        focusConfirm: false,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Sí",
                        cancelButtonText: "No",

                        customClass: {
                          confirmButton: "btn-success",
                          cancelButton: "btn-danger",
                        },
                      })
                      .then((result) => {

                        if (result.isConfirmed) {
                          if (this.idEtapa !== undefined && this.idEtapa !== null) {
                            this.guardarValidacion()
                          } else {
                            this.$swal
                                .fire({
                                  title:
                                      "<strong>¿Estás seguro de generar el PTI?</strong>",
                                  focusConfirm: false,
                                  icon: "warning",
                                  showCancelButton: true,
                                  confirmButtonText: "Sí",
                                  cancelButtonText: "No",

                                  customClass: {
                                    confirmButton: "btn-success",
                                    cancelButton: "btn-danger",
                                  },
                                })
                                .then((result) => {
                                    this.loader = false;
                                  if (result.isConfirmed) {
                                    this.obtenerNivel();
                                  }
                                })
                          }
                        }else{
                            this.loader = false;
                        }
                      });

                })
            }
            
          } else if(bandera == false){
            this.$swal
                .fire({
                  title:
                      "<strong>¿Estás seguro que haz terminado la validación del pti?</strong>",
                  focusConfirm: false,
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Sí",
                  cancelButtonText: "No",

                  customClass: {
                    confirmButton: "btn-success",
                    cancelButton: "btn-danger",
                  },
                })
                .then((result) => {
                  if (result.isConfirmed) {
                    if (this.idEtapa !== undefined && this.idEtapa !== null) {
                      this.guardarValidacion()
                    } else {

                      this.$swal
                          .fire({
                            title:
                                "<strong>¿Estás seguro de generar el PTI?</strong>",
                            focusConfirm: false,
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonText: "Sí",
                            cancelButtonText: "No",

                            customClass: {
                              confirmButton: "btn-success",
                              cancelButton: "btn-danger",
                            },
                          })
                          .then((result) => {
                            this.loader = false;
                            if (result.isConfirmed) {
                              this.obtenerNivel();
                            }
                          })
                    }
                  }
                });
          }


        }
      },
      obtenerNivel(){
        this.loading = true; 
        this.ptiPrsuntivoServicio.obtenerNivel(this.datos(false, false)).then(
            (response) => {
                this.nivelPTI = response
            }).finally(
                () => {
                    this.loading = false
                    this.enviarDatosAGuardar()
                }
            )
      },
        enviarDatosAGuardar() {

            this.nivelPTI;

            if(this.titulo.toUpperCase() == "SOLICITUD DE PTI DESCENTRALIZADO"){
                let nivel = "";
                if(this.nivelPTI == 1){
                    nivel = "Nivel I"
                }else if(this.nivelPTI == 2){
                    nivel = "Nivel II"
                }else if(this.nivelPTI == 3){
                    nivel = "Nivel III"
                }else{
                    nivel = "Nivel IV"
                }
                if(this.nivelPTI == 1 || this.nivelPTI == 2){
                    this.loading = true
                    //mandar a la bandeja de revision de pti
                    this.ptiPrsuntivoServicio.guardarDeserializado(this.datos(false, false)).then((response) =>{
                        if(response > 0){
                            this.loader = false;
                            this.loading = false
                            this.$swal.fire({
                                icon: 'success',
                                title: 'PTI ' + nivel + ' guardado exitosamente',
                                text: 'Este PTI es de ' + nivel + ', por lo que está listo para su presentación. Puedes revisarlo en la bandeja "Unidad de presentación".',
                                showCancelButton: true,
                                confirmButtonText: "Ir a bandeja",
                                cancelButtonText: "Cerrar",
                                customClass: {
                                    confirmButton: 'rounded-pill',
                                    cancelButton: 'rounded-pill'
                                },
                                allowOutsideClick: false,
                            }).then((aceptar) => {
                                this.noTienePti = false
                                this.formulario = {
                                    fechaSolicitud: new Date().toLocaleString(),
                                    idClinica: null,
                                    clinica: null,
                                    idEmpleado: null,
                                    empleado: null,
                                    idFlujoPx1: null,
                                    idTagMotivoCita: null,
                                    enfermedadSistemica: null,
                                    idKit: false,
                                    tomaHerramienta: false,
                                    candidatoOrtodoncia: false,
                                    informacionPaciente: null,
                                    habitos: null,
                                    bruxismo: false,
                                    placaSarro: false,
                                    periodontitis1: false,
                                    periodontitis2: false,
                                    periodontitis3: false,
                                    periodontitis4: false,
                                    dientes: []
                                }
                                if (this.existeRechazoDesentralizado){
                                    this.detalle = false;
                                }
                                if(aceptar.isConfirmed){
                                    this.$router.push({name: "bandejaEmbajadorHallazgo"});
                                }
                            });
                        }
                    })
                }else{
                    this.$swal.fire({
                        icon: 'success',
                        title: 'PTI '+ nivel +' enviado ¿DESEA GESTIONAR APOYO PARA VALIDARLO?',
                        showCancelButton: true,
                        showConfirmButton: true,
                        confirmButtonText: "Sí",
                        cancelButtonText: "No, enviar a up",
                        customClass: {
                            confirmButton: 'rounded-pill',
                            cancelButton: 'rounded-pill'
                        },
                        allowOutsideClick: false,
                    }).then((respuesta) => {
                        if(respuesta.isConfirmed){
                            this.$swal.fire({
                                icon: 'success',
                                title: 'Enviar PTI '+ nivel + ' a validación',
                                text: 'El PTI ENTRARÁ A PROCESO DE VALIDACIÓN POR OG, ¿DE QUIEN SE SOLICITA EL APOYO PARA VALIDAR?',
                                showCancelButton: true,
                                showConfirmButton: true,
                                confirmButtonText: "Centro de validación",
                                cancelButtonText: "ESPECIALISTAS CLINICA",
                                customClass: {
                                    confirmButton: 'rounded-pill',
                                    cancelButton: 'rounded-pill'
                                },
                                allowOutsideClick: false,
                            }).then((res) => {
                                if(res.isConfirmed){
                                    this.loading = true
                                    //mandar a la bandeja de cdx
                                    this.ptiPrsuntivoServicio.guardarDeserializado(this.datos(true, false)).then((response) =>{
                                        if(response > 0){
                                            this.loader = false;
                                            this.loading = false
                                            this.$swal.fire({
                                                icon: 'success',
                                                title: 'PTI ' + nivel + ' enviado',
                                                text: 'El PTI se envió al centro de validación y está pendiente de revisión, una vez validado regresará a la bandeja "Unidad de presentación". Podrás darle seguimiento en la bandeja de validación especialistas',
                                                showCancelButton: true,
                                                showConfirmButton: false,
                                                cancelButtonText: "Cerrar",
                                                customClass: {
                                                    confirmButton: 'rounded-pill',
                                                    cancelButton: 'rounded-pill'
                                                },
                                                allowOutsideClick: false,
                                            }).then(() => {
                                                this.noTienePti = false
                                                this.formulario = {
                                                    fechaSolicitud: new Date().toLocaleString(),
                                                    idClinica: null,
                                                    clinica: null,
                                                    idEmpleado: null,
                                                    empleado: null,
                                                    idFlujoPx1: null,
                                                    idTagMotivoCita: null,
                                                    enfermedadSistemica: null,
                                                    idKit: false,
                                                    tomaHerramienta: false,
                                                    candidatoOrtodoncia: false,
                                                    informacionPaciente: null,
                                                    habitos: null,
                                                    bruxismo: false,
                                                    placaSarro: false,
                                                    periodontitis1: false,
                                                    periodontitis2: false,
                                                    periodontitis3: false,
                                                    periodontitis4: false,
                                                    dientes: []
                                                }
                                                if (this.existeRechazoDesentralizado){
                                                    this.detalle = false;
                                                }
                                            });
                                        }
                                    })
                                }else{
                                    this.loading = true
                                    //mandar a la bandeja de especialistas
                                    this.ptiPrsuntivoServicio.guardarDeserializado(this.datos(true, true)).then((response) =>{
                                        if(response > 0){
                                            this.loader = false;
                                            this.loading = false
                                            this.$swal.fire({
                                                icon: 'success',
                                                title: 'PTI ' + nivel + ' en validación',
                                                text: 'El PTI ESTÁ GUARDADO COMO PENDIENTE DE VALIDACIÓN POR OG, PARA RETOMAR ACUDE A LA BANDEJA DE VALIDACIÓN OG.',
                                                showCancelButton: true,
                                                showConfirmButton: true,
                                                confirmButtonText: "Ir a la bandeja",
                                                cancelButtonText: "Cerrar",
                                                customClass: {
                                                    confirmButton: 'rounded-pill',
                                                    cancelButton: 'rounded-pill'
                                                },
                                                allowOutsideClick: false,
                                            }).then((response) => {
                                                this.noTienePti = false
                                                this.formulario = {
                                                    fechaSolicitud: new Date().toLocaleString(),
                                                    idClinica: null,
                                                    clinica: null,
                                                    idEmpleado: null,
                                                    empleado: null,
                                                    idFlujoPx1: null,
                                                    idTagMotivoCita: null,
                                                    enfermedadSistemica: null,
                                                    idKit: false,
                                                    tomaHerramienta: false,
                                                    candidatoOrtodoncia: false,
                                                    informacionPaciente: null,
                                                    habitos: null,
                                                    bruxismo: false,
                                                    placaSarro: false,
                                                    periodontitis1: false,
                                                    periodontitis2: false,
                                                    periodontitis3: false,
                                                    periodontitis4: false,
                                                    dientes: []
                                                }
                                                if (this.existeRechazoDesentralizado){
                                                    this.detalle = false;
                                                }
                                                if(response.isConfirmed){
                                                    this.$router.push({name: "bandejaRevisionEspecialistaClinica"});
                                                }
                                            });
                                        }
                                    })
                                }
                            });
                        }else{
                            this.loading = true
                            //mandar como si fuera nivel 1 o 2
                            this.ptiPrsuntivoServicio.guardarDeserializado(this.datos(false, false)).then((response) =>{
                                if(response > 0){
                                    this.loader = false;
                                    this.loading = false
                                    this.noTienePti = false
                                    this.formulario = {
                                        fechaSolicitud: new Date().toLocaleString(),
                                        idClinica: null,
                                        clinica: null,
                                        idEmpleado: null,
                                        empleado: null,
                                        idFlujoPx1: null,
                                        idTagMotivoCita: null,
                                        enfermedadSistemica: null,
                                        idKit: false,
                                        tomaHerramienta: false,
                                        candidatoOrtodoncia: false,
                                        informacionPaciente: null,
                                        habitos: null,
                                        bruxismo: false,
                                        placaSarro: false,
                                        periodontitis1: false,
                                        periodontitis2: false,
                                        periodontitis3: false,
                                        periodontitis4: false,
                                        dientes: []
                                    }
                                }
                            })
                        }
                    });
                }
            }else{
                this.loading = true
                this.ptiPrsuntivoServicio.guardarDeserializado(this.datos(false, false)).then(
                    () => {
                        this.loading = false;
                        this.loader = false;
                        this.$swal.fire({
                            icon: 'success',
                            title: 'Se guardó correctamente la información'
                        }).then(() => {
                            this.noTienePti = false
                            this.formulario = {
                                fechaSolicitud: new Date().toLocaleString(),
                                idClinica: null,
                                clinica: null,
                                idEmpleado: null,
                                empleado: null,
                                idFlujoPx1: null,
                                idTagMotivoCita: null,
                                enfermedadSistemica: null,
                                idKit: false,
                                tomaHerramienta: false,
                                candidatoOrtodoncia: false,
                                informacionPaciente: null,
                                habitos: null,
                                bruxismo: false,
                                placaSarro: false,
                                periodontitis1: false,
                                periodontitis2: false,
                                periodontitis3: false,
                                periodontitis4: false,
                                dientes: []
                            }
                        });
                    }
                ).finally(
                    () => {
                        this.loader = false;
                        this.loading = false
                    }
                )
            }
        },
      guardarBorrador(numero) {
            this.loader = true;
            this.ptiPrsuntivoServicio.guardarBorrador(this.datos(false, false), numero).then(
                () => {
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Se guardó correctamente la información'
                    }).then(() => {
                        this.noTienePti = false
                        this.formulario = {
                            fechaSolicitud: new Date().toLocaleString(),
                            idClinica: null,
                            clinica: null,
                            idEmpleado: null,
                            empleado: null,
                            idFlujoPx1: null,
                            idTagMotivoCita: null,
                            enfermedadSistemica: null,
                            idKit: false,
                            tomaHerramienta: false,
                            candidatoOrtodoncia: false,
                            informacionPaciente: null,
                            habitos: null,
                            bruxismo: false,
                            placaSarro: false,
                            periodontitis1: false,
                            periodontitis2: false,
                            periodontitis3: false,
                            periodontitis4: false,
                            dientes: []
                        }
                    });
                }
            ).finally(
                () => {
                    this.loader = false
                }
            )
        },
        guardarValidacion() {
            this.loader = true;

            this.ptiPrsuntivoServicio.guardarValidacionDeserializado(this.datos(false, false)).then(
                () => {
                    this.disable = true;
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Se guardó correctamente la información'
                    }).then(() => {
                        this.$router.back();
                    });

                }
            ).finally(
                () => {
                    this.loader = false
                }
            )
        },
        datos(rev, cdx) {
            const datos = JSON.parse(JSON.stringify(this.formulario))
            if(rev){
                if(cdx){
                    datos.rutaExpediente = '';
                    datos.idPaciente = this.id_Paciente;
                    datos.idDenticion = this.id_denticion;
                    datos.descentralizado = this.descentralizado;
                    datos.idEtapa = this.etapaRechazo;
                    datos.idSolicitud = this.solicitudRechazo;
                    datos.idPti = this.idPti;
                    datos.idSolicitudEtapa = this.idSolicitudEtapa;
                    datos.dientes.forEach(diente => {
                        const txs = [];
                        diente.tratamientos.forEach((item, index) => {
                            const tratamientosDiente = item.map((tx, i) => {
                                tx.orden = i;
                            //    tx.cantidad = 1;
                                tx.opcion = index + 1;
                                return tx
                            })
                            txs.push(tratamientosDiente);
                        });
                        diente.idDiente = diente.diente.idDiente
                        diente.tratamientos = txs;
                    })
                    datos.revision = rev;
                    datos.revisionEspecialista = cdx;
                }else{
                    datos.rutaExpediente = '';
                    datos.idPaciente = this.id_Paciente;
                    datos.idDenticion = this.id_denticion;
                    datos.descentralizado = this.descentralizado;
                    datos.idEtapa = this.etapaRechazo;
                    datos.idSolicitud = this.solicitudRechazo;
                    datos.idPti = this.idPti;
                    datos.idSolicitudEtapa = this.idSolicitudEtapa;
                    datos.dientes.forEach(diente => {
                        const txs = [];
                        diente.tratamientos.forEach((item, index) => {
                            const tratamientosDiente = item.map((tx, i) => {
                                tx.orden = i;
                            //    tx.cantidad = 1;
                                tx.opcion = index + 1;
                                return tx
                            })
                            txs.push(tratamientosDiente);
                        });
                        diente.idDiente = diente.diente.idDiente
                        diente.tratamientos = txs;
                    })
                    datos.revision = rev;
                    datos.revisionEspecialista = cdx;
                }
            }else{
                datos.rutaExpediente = '';
                datos.idPaciente = this.id_Paciente;
                datos.idDenticion = this.id_denticion;
                datos.descentralizado = this.descentralizado;
                datos.idEtapa = this.etapaRechazo;
                datos.idSolicitud = this.solicitudRechazo;
                datos.idPti = this.idPti;
                datos.idSolicitudEtapa = this.idSolicitudEtapa;
                datos.dientes.forEach(diente => {
                    const txs = [];
                    diente.tratamientos.forEach((item, index) => {
                        const tratamientosDiente = item.map((tx, i) => {
                            tx.orden = i;
                        //    tx.cantidad = 1;
                            tx.opcion = index + 1;
                            return tx
                        })
                        txs.push(tratamientosDiente);
                    });
                    diente.idDiente = diente.diente.idDiente
                    diente.tratamientos = txs;
                })
                datos.revision = rev;
                datos.revisionEspecialista = cdx;
            }
            return datos;
        },
        validateState(name) {
            const {$dirty, $error} = this.$v.formulario[name];
            return $dirty ? !$error : null;
        },
        selectClass(attribute) {
            let state = this.validateState(attribute)
            if (state) {
                return 'border rounded-lg border-success'
            } else if (state === false) {
                return 'border rounded-lg border-danger'
            } else {
                return ''
            }
        },
        validateStateArray(name, index, name2) {
            const {$dirty, $error} = this.$v.formulario[name].$each[index][name2];
            return $dirty ? !$error : null;
        },
        selectClassArray(name, index, name2) {
            let state = this.validateStateArray(name, index, name2);
            if (state) {
                return "border rounded-lg border-success";
            } else if (state === false) {
                return "border rounded-lg border-danger";
            } else {
                return "";
            }
        },

        rutaClinica() {
            this.ptiPrsuntivoServicio.obtenerRutaClinica(this.formulario.dientes).then((response) => {
                this.listaRuta = response
            })
        },

        indexDatosAdicionales(item) {
            let aparecer = -1
            this.formulario.dientes.forEach((d,i) => {
                if (d.padecimiento.idPadecimiento === item.idPadecimiento && d.diente.idDiente === item.diente.idDiente){
                    aparecer = i;
                }

            })

            return aparecer;
        },
        irTabExpediente() {
            this.tabIndex = 1
        },
        desplegar() {

            this.formulario.dientes.forEach(d => d.visible = true)
            this.activo = true
        },
        ocultar() {
            this.formulario.dientes.forEach(d => d.visible = false)
            this.activo = false
        },
        ordenarODS(){
            let dientesOrdenados = [];
            // dar orden a boca completa
            this.formulario.dientes.forEach(d => {
                d.cambio = false;
                if(d.diente.idDiente == 59){
                    if(d.padecimiento == null || (d.padecimiento.idPadecimiento != 179 
                    && d.padecimiento.idPadecimiento != 74 && d.padecimiento.idPadecimiento != 73)){
                        d.diente.orden = 33
                    } else if(d.padecimiento.idPadecimiento == 73){
                        d.diente.orden = 34
                    } else if(d.padecimiento.idPadecimiento == 74){
                        d.diente.orden = 35
                    } else if(d.padecimiento.idPadecimiento == 179){
                        d.diente.orden = 36
                    }
                }
                // dar orden a superior
                if(d.diente.idDiente == 57){
                    if(d.padecimiento == null || (d.padecimiento.idPadecimiento != 165 
                    && d.padecimiento.idPadecimiento != 162 && d.padecimiento.idPadecimiento != 49 
                    && d.padecimiento.idPadecimiento != 10)){
                        d.diente.orden = 37
                    } else if(d.padecimiento.idPadecimiento == 10){
                        d.diente.orden = 38
                    } else if(d.padecimiento.idPadecimiento == 49){
                        d.diente.orden = 39
                    } else if(d.padecimiento.idPadecimiento == 162){
                        d.diente.orden = 40
                    } else if(d.padecimiento.idPadecimiento == 165){
                        d.diente.orden = 41
                    }
                }
                // dar orden a inferior
                if(d.diente.idDiente == 58){
                    if(d.padecimiento == null || (d.padecimiento.idPadecimiento != 49 
                    && d.padecimiento.idPadecimiento != 162 && d.padecimiento.idPadecimiento != 165)){
                        d.diente.orden = 42
                    } else if(d.padecimiento.idPadecimiento == 49){
                        d.diente.orden = 43
                    } else if(d.padecimiento.idPadecimiento == 162){
                        d.diente.orden = 44
                    } else if(d.padecimiento.idPadecimiento == 165){
                        d.diente.orden = 45
                    }
                }
            });
            dientesOrdenados = this.formulario.dientes
            let dientes = dientesOrdenados.map(dior => dior.diente.orden);
            var length = dientes.length; 
            for (var i = 0; i < length; i++) {
                for (var j = 0; j < (length - i - 1); j++) {
                    if(dientes[j] > dientes[j+1]) {
                        var tmp = dientes[j]; 
                        dientes[j] = dientes[j+1]; 
                        dientes[j+1] = tmp; 
                    }
                }
            }
            this.load = true;
            this.formulario.dientes = [];
            setTimeout(() => {
                for (let i = 0; i < dientes.length; i++) {
                    this.formulario.dientes.push(dientesOrdenados[dientesOrdenados.findIndex(d => d.diente.orden == dientes[i])]);
                }
                this.load = false;
            }, 500);
            this.load = false;
        },
        agregarODS(){
            this.multiplesODS = true;
            this.multiplesDientes = [];
            this.multiplesDientesSeleccionados = [];
        },
        cancelarMultiple(){
            this.multiplesODS = false;
            this.multiplesDientesSeleccionados = [];
        },
        seleccionarTodo() {
            this.todo = !this.todo
            this.formulario.dientes.forEach(d => d.seleccionar = this.todo)
        },
        validacionEliminar(){
            const index = [];
            this.formulario.dientes.forEach((d, i) => {
                if (d.seleccionar) {
                    index.push(i);
                }
            })

            if (index.length === 0) {
                this.$swal.fire({
                    html: '<div style="text-align:left;font-weight: bold; color: #0c26a7"><i class="fa fa-times-circle-o"></i> Eliminar órganos dentales</div> <br>' +
                        '<div style="text-align:left; font-size: small">No se encontraron elementos seleccionados para eliminar, por favor seleccione elementos para eliminarlos</div>',
                    confirmButtonText: 'Cerrar',
                    customClass: {
                        confirmButton: "text-small",
                    },
                    allowOutsideClick: false
                }).then((aceptar) =>{
                    if(aceptar.isConfirmed){
                        this.selected = null;
                        return;
                    }
                });
            }
        },
        eliminarVarios() {
            const index = [];
            this.formulario.dientes.forEach((d, i) => {
                if (d.seleccionar) {
                    index.push(i);
                }
            })

            if (index.length === 0) {
                this.selected = null;
                this.$swal.fire({
                    html: '<div style="text-align:left;font-weight: bold; color: #0c26a7"><i class="fa fa-times-circle-o"></i> Eliminar órganos dentales</div> <br>' +
                        '<div style="text-align:left; font-size: small">No se encontraron elementos seleccionados para eliminar, por favor seleccione elementos para eliminarlos</div>',
                    confirmButtonText: 'Cerrar',
                    customClass: {
                        confirmButton: "text-small",
                    },
                    allowOutsideClick: false
                });
                return;
            }

            if(this.selected == 'ods'){
                this.$swal
                .fire({
                    title: "<span style='font-size: small'>¿Estas seguro de que quieres eliminar todos los Padecimientos?</span>",
                    focusConfirm: false,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Sí",
                    cancelButtonText: "No",
                    customClass: {
                        confirmButton: "btn-success text-small",
                        cancelButton: "btn-danger text-small",
                    },
                })
                .then((result) => {

                    if (result.isConfirmed) {
                        index.reverse().forEach(i => {
                            this.formulario.dientes.splice(i, 1)
                        })
                        this.dientesSeleccionados = this.formulario.dientes.map(d => d.diente);
                        this.rutaClinica();
                    }
                });
            }else if(this.selected == 'tratamientos'){
                this.$swal
                .fire({
                    title: "<span style='font-size: small'>¿Estas seguro de que quieres eliminar todos los Tratamientos?</span>",
                    focusConfirm: false,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Sí",
                    cancelButtonText: "No",
                    customClass: {
                        confirmButton: "btn-success text-small",
                        cancelButton: "btn-danger text-small",
                    },
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        index.reverse().forEach(i => {
                            this.formulario.dientes[i].tratamientos = [];
                            this.formulario.dientes[i].tratamientos.push([]);
                            this.formulario.dientes[i].tratamientos.push([]);
                            this.formulario.dientes[i].tratamientos.push([]);
                        })
                        this.rutaClinica();
                    }
                });
            }else if(this.selected == '1'){
                this.$swal
                .fire({
                    title: "<span style='font-size: small'>¿Estas seguro de que quieres eliminar todos los Tratamientos del PTI I?</span>",
                    focusConfirm: false,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Sí",
                    cancelButtonText: "No",
                    customClass: {
                        confirmButton: "btn-success text-small",
                        cancelButton: "btn-danger text-small",
                    },
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        index.reverse().forEach(i => {
                            this.formulario.dientes[i].tratamientos.splice(0, 1, []);
                        })
                        this.dientesSeleccionados = this.formulario.dientes.map(d => d.diente);
                        this.rutaClinica();
                    }
                });
            }else if(this.selected == '2'){
                this.$swal
                .fire({
                    title: "<span style='font-size: small'>¿Estas seguro de que quieres eliminar todos los Tratamientos del PTI II?</span>",
                    focusConfirm: false,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Sí",
                    cancelButtonText: "No",
                    customClass: {
                        confirmButton: "btn-success text-small",
                        cancelButton: "btn-danger text-small",
                    },
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        index.reverse().forEach(i => {
                            this.formulario.dientes[i].tratamientos.splice(1, 1, []);
                        })
                        this.dientesSeleccionados = this.formulario.dientes.map(d => d.diente);
                        this.rutaClinica();
                    }
                });
            }else if(this.selected == '3'){
                this.$swal
                .fire({
                    title: "<span style='font-size: small'>¿Estas seguro de que quieres eliminar todos los Tratamientos del PTI III?</span>",
                    focusConfirm: false,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Sí",
                    cancelButtonText: "No",
                    customClass: {
                        confirmButton: "btn-success text-small",
                        cancelButton: "btn-danger text-small",
                    },
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        index.reverse().forEach(i => {
                            this.formulario.dientes[i].tratamientos.splice(2, 1, []);
                        })
                        this.dientesSeleccionados = this.formulario.dientes.map(d => d.diente);
                        this.rutaClinica();
                    }
                });
            }
        },
        obtenerDiagnosticador(){
            this.$http
                .get(this.$api + "ptipresuntivo/obtener/usuario")
                .then((response) => {
                    this.grupo = response.data.data;
                })
                .catch((error) => {
                    console.error(
                        "Error al obtener los grupos del usuario" +
                        error
                    );
                })
        },
      obtenerBorrador() {
          const params = {
            idPaciente: this.id_Paciente
          }
        this.ptiPrsuntivoServicio.obtenerBorrador(params).then(
            res => {
              if (res != null){
                this.formulario = res;
                this.dientesSeleccionados = this.formulario.dientes.map(d => d.diente);
                this.rutaClinica();
                this.borradorExistente = true
              }else {
                this.obtenerEnfermedadesSistemicas();
              }
            }
        )
      },

      actualizarPadsAddNoReq(datosAct) {
        // this.diente.padecimientosAdicionalesNoReq = datosAct
        const dienteActualizar = this.formulario.dientes.find(d=>d.diente.idDiente === datosAct.idDiente);

        if (dienteActualizar != undefined && dienteActualizar != null) {
          dienteActualizar.padecimientosAdicionalesNoReq = datosAct.pads;
        }

      },

      obtenerDescTagMotivoCita() {
        if (this.tagmotivocitaDatosArrayOriginal != undefined && this.tagmotivocitaDatosArrayOriginal != null) {
          const tagEncontrado = this.tagmotivocitaDatosArrayOriginal.find(it =>
              it.idTagMotivoCita === this.formulario.idTagMotivoCita);

          if (tagEncontrado != undefined && tagEncontrado != null) {
            return tagEncontrado.descripcionTagMotivoCita;
          }
        }
        return "";
      }

    },
    watch: {
        tabIndex() {
            this.$refs.carrusel.obtenerImagenes()
        },
        bloquearformularioTag() {
            if (!this.bloquearformularioTag) {
                this.formulario.idTagMotivoCita = this.tagCitaOriginal;
            }
        }
    },
}
</script>

<style scoped>
.container-fluid {
    background-color: white !important;
}

label {
    color: rgb(50, 50, 50) !important;
}

.box-comentarios {
  /*border-radius: 5px;*/
  max-height: 100px;
  overflow: auto;
  /*border: solid 1px #ced4da;*/
  padding: 5px;
  height: 100px;
}

</style>
